import React, { FC } from 'react';
import Tooltip from 'HOC/Tooltip';
import Pill from 'Components/Pill';
import injectSheet from 'react-jss';
import { AttributeObject } from '../classes/attributes.classes';
import styleSheet from './styles';

interface Props {
  classes?: any;
  text?: string;
  groupCount?: string;
  attribute?: AttributeObject;
  focusOnHover?: boolean;
}

const StandardPill: FC<Props> = (props: Props) => {
  const { classes, text, groupCount, attribute, focusOnHover } = props;

  const tooltipDescription = (
    <div className={classes.standardPillDescription}>
      {attribute.attributes.map((toolText: string) => {
        return <div key={toolText}>{toolText}</div>;
      })}
    </div>
  );

  return (
    <div className={classes.pillContainerHorizontal}>
      <Tooltip
        position="right"
        offsetTop={-5}
        offsetLeft={86}
        text={tooltipDescription}
        width="260px"
        overrideEvents={{
          showToolTip: ['onMouseEnter', 'onFocus'],
          hideToolTip: ['onBlur', 'onMouseLeave'],
        }}
        parentText="Standard"
      >
        <Pill text={text} groupCount={groupCount} focusOnHover={focusOnHover} />
      </Tooltip>
    </div>
  );
};

StandardPill.defaultProps = {
  classes: {},
  text: '',
  groupCount: '',
  attribute: { label: '', attributes: [], type: 'engagement' },
  focusOnHover: false,
};

export default injectSheet(styleSheet)(StandardPill);
